import React, { useCallback } from "react";
import { Stack } from "@mui/material";
import FieldInputText from "components/FieldInputText";
import FieldInputSelect from "components/FieldInputSelect";
import { Units } from "constants/common";
import * as Yup from "yup";
import BaseForm from "./BaseForm";

const FormDimensions = () => {
    const UnitsData = Units.map((entry: any) => {
      const { text:label, value} = entry;
      return {
        label,
        value
      }
    });
    const schema = Yup.object().shape({
        voxelSize: Yup.number().required().label("Voxel Size"),
        units: Yup.string().required().label("Units"),
        originX: Yup.number().required().label("Project Origin X"),
        originY: Yup.number().required().label("Project Origin Y"),
        originZ: Yup.number().required().label("Project Origin Z"),
    })
  
    const handleChange = (prop: string, methods: any) => (event: any) => {
        const value = event.target.value;
        const values = methods.getValues();
        let voxelSize = parseFloat(values.voxelSize);

        prop === "voxelSize" && (voxelSize = parseFloat(value));
        
        const dimX = (1 << 24) * 40 * voxelSize;
        const dimY = (1 << 24) * 40 * voxelSize;
        const dimZ = (1 << 12) * 40 * voxelSize;
        let newValues;
        switch (prop) {
            case "voxelSize": {
                newValues = {
                    ...values,
                    voxelSize: value,
                    minX: parseInt(values.originX) - dimX,
                    maxX: parseInt(values.originX) + dimX,
                    minY: parseInt(values.originY) - dimY,
                    maxY: parseInt(values.originY) + dimY,
                    minZ: parseInt(values.originZ) - dimZ,
                    maxZ: parseInt(values.originZ) + dimZ,
                };
                break;
            }
            case "originX": {
                newValues = {
                    ...values,
                    originX: value,
                    minX: parseInt(value) - dimX,
                    maxX: parseInt(value) + dimX,
                };
                break;
            }
            case "originY": {
                newValues = {
                    ...values,
                    originY: value,
                    minY: parseInt(value) - dimY,
                    maxY: parseInt(value) + dimY,
                };
                break;
            }
            case "originZ": {
                newValues = {
                    ...values,
                    originZ: value,
                    minZ: parseInt(value) - dimZ,
                    maxZ: parseInt(value) + dimZ,
                };
                break;
            }
            default:
                newValues = { ...values, [prop]: value };
        }

        methods.reset(newValues);
    };

    return (
        <BaseForm
            schema={schema}
            render={(methods: any) => {
                return (
                    <>
                    <FieldInputText 
                            name="voxelSize"
                            type="number"
                            control={methods.control} 
                            label="Voxel Size" 
                            step={0.05}
                            min={0.1}
                            max={10}
                            changeHandler={handleChange('voxelSize', methods)}
                        />
                        <FieldInputSelect 
                            name="units" 
                            options={UnitsData}
                            control={methods.control} 
                            label="Units" 
                            changeHandler={handleChange('units', methods)}
                        />
                        <FieldInputText 
                            name="originX"
                            type="number"
                            control={methods.control} 
                            label="Project Origin X"
                            min={0}
                            changeHandler={handleChange('originX', methods)}
                        />
                        <Stack 
                            gap={5}
                            direction="row"
                            sx={{
                                justifyContent: "space-between",
                                alignItems: "center",
                            }}
                        >
                            <FieldInputText 
                                name="minX"
                                type="number"
                                control={methods.control} 
                                label="Min X"
                                disabled
                            />
                            <FieldInputText 
                                name="maxX"
                                type="number"
                                control={methods.control} 
                                label=" Max X" 
                                disabled
                            />
                        </Stack>
                        <FieldInputText 
                            name="originY"
                            type="number"
                            control={methods.control} 
                            label="Project Origin Y" 
                            min={0}
                            changeHandler={handleChange('originY', methods)}
                        />
                        <Stack 
                            gap={5}
                            direction="row"
                            sx={{
                                justifyContent: "space-between",
                                alignItems: "center",
                            }}
                        >
                            <FieldInputText 
                                name="minY"
                                type="number"
                                control={methods.control} 
                                label="Min Y"
                                disabled
                            />
                            <FieldInputText 
                                name="maxY"
                                type="number"
                                control={methods.control} 
                                label=" Max Y" 
                                disabled
                            />
                        </Stack>
                        <FieldInputText 
                            name="originZ"
                            type="number"
                            control={methods.control} 
                            label="Project Origin Z"
                            min={0}
                            changeHandler={handleChange('originZ', methods)}
                        />
                        <Stack 
                            gap={5}
                            direction="row"
                            sx={{
                                justifyContent: "space-between",
                                alignItems: "center",
                            }}
                        >
                            <FieldInputText 
                                name="minZ"
                                type="number"
                                control={methods.control} 
                                label="Min Z"
                                disabled
                            />
                            <FieldInputText 
                                name="maxZ"
                                type="number"
                                control={methods.control} 
                                label=" Max Z" 
                                disabled
                            />
                        </Stack>
                    </>
                )
            }}
        />
    );
  }
  
  export default FormDimensions;